import(/* webpackMode: "eager", webpackExports: ["CartContentOptimisticGuard"] */ "/home/vsts/work/1/s/apps/website/src/app/(frontend)/[locale]/(public)/(purchasing)/cart/cart.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OptimisticLoadingSpinner"] */ "/home/vsts/work/1/s/apps/website/src/modules/cart/cartPopup.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartItemListContext"] */ "/home/vsts/work/1/s/apps/website/src/modules/cart/context/cartItemList.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Price"] */ "/home/vsts/work/1/s/apps/website/src/modules/cart/items/price.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartItemRemoveButton"] */ "/home/vsts/work/1/s/apps/website/src/modules/cart/items/removeItemButton.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartEmptyMessage"] */ "/home/vsts/work/1/s/apps/website/src/modules/cart/misc/cartEmptyMessage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartLoadErrorNotification"] */ "/home/vsts/work/1/s/apps/website/src/modules/cart/misc/cartLoadErrorNotification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartAmountOptimisticGuard"] */ "/home/vsts/work/1/s/apps/website/src/modules/cart/misc/headerCartButton.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationsProvider"] */ "/home/vsts/work/1/s/apps/website/src/modules/localization/translations.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/vsts/work/1/s/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/image-component.js");
